import { render, staticRenderFns } from "./OrderCompletePix.vue?vue&type=template&id=0f142605&scoped=true"
import script from "./OrderCompletePix.vue?vue&type=script&lang=js"
export * from "./OrderCompletePix.vue?vue&type=script&lang=js"
import style0 from "./OrderCompletePix.vue?vue&type=style&index=0&id=0f142605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f142605",
  null
  
)

export default component.exports